/**
 * React Query Provider
 * 서버 상태 관리 및 캐싱
 */

import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';
import { queryClient } from './queryClient';

/**
 * QueryProvider 컴포넌트
 */
interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools 비활성화 - 필요 시 주석 해제 */}
      {/* {import.meta.env.DEV && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-right"
        />
      )} */}
    </QueryClientProvider>
  );
}
